import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const instance = axios.create({ baseURL: API });

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("regenx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default instance;
